var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"oidc-auth-link__wrapper"},[_vm._l((_vm.authProviders),function(authProvider){return [_c('ABButton',{key:authProvider.id,on:{"click":function($event){$event.preventDefault();return _vm.login(authProvider)}}},[_vm._v("\n      "+_vm._s(_vm.getLabel(authProvider))+"\n    ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }